import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const DangerTriangle = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8.001 14c-4.33 0-6.029-.307-6.304-1.864s1.487-4.484 2.03-5.45C5.543 3.456 6.777 2 8 2s2.459 1.456 4.275 4.686c.543.966 2.305 3.893 2.03 5.45S12.33 14 8 14"
        clipRule="evenodd"
      />
      <path
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8.001 5.666v2.597M7.998 10.597h.006"
      />
    </svg>
  );
};
export default DangerTriangle;
